var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBdlty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13145 2.3252L11.8189 3.9627C12.8814 4.43144 12.8814 5.20644 11.8189 5.67519L8.13145 7.31269C7.7127 7.50019 7.0252 7.50019 6.60645 7.31269L2.91895 5.67519C1.85645 5.20644 1.85645 4.43144 2.91895 3.9627L6.60645 2.3252C7.0252 2.1377 7.7127 2.1377 8.13145 2.3252Z",
    stroke: "#1A203F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 7.375C1.875 7.9 2.26875 8.50625 2.75 8.71875L6.99375 10.6063C7.31875 10.75 7.6875 10.75 8.00625 10.6063L12.25 8.71875C12.7313 8.50625 13.125 7.9 13.125 7.375",
    stroke: "#1A203F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 10.5C1.875 11.0813 2.21875 11.6062 2.75 11.8437L6.99375 13.7313C7.31875 13.875 7.6875 13.875 8.00625 13.7313L12.25 11.8437C12.7813 11.6062 13.125 11.0813 13.125 10.5",
    stroke: "#1A203F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBdlty);
export default __webpack_public_path__ + "static/media/bdlty.c68be16cffc61c01ac2611548d9cf54a.svg";
export { ForwardRef as ReactComponent };